import { create } from 'zustand';

export type ViewMode = 'map' | 'documentation' | 'orders' | 'customers' | 'tasks'
  // Hľadanie zákazníka naprieč projektami — samostatná obrazovka pre technika
  | 'customer-search';

interface ViewState {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export const useViewStore = create<ViewState>((set) => ({
  viewMode: 'map',
  setViewMode: (mode) => set({ viewMode: mode }),
}));

